import axios from "axios";
import { convertUrl } from "../helpers/helper";

const state = {
  pages: [],
  pagesList: [],
  paginationPages: 1,
  paginationCurrentPage: 1,
  validationErrors: [],
  isLoading: false,
};

const mutations = {
  SET_PAGES(state, data) {
    state.pages = data;
  },

  SET_PAGES_LIST(state, data) {
    state.pagesList = data;
  },

  SET_PAGINATION_PAGES(state, data) {
    state.paginationPages = data;
  },

  SET_PAGINATION_CURRENT_PAGE(state, data) {
    state.paginationCurrentPage = data;
  },

  SET_VALIDATION_ERRORS(state, data) {
    state.validationErrors = data;
  },

  SET_IS_LOADING(state, data) {
    state.isLoading = data;
  },
};

const actions = {
  async getPages({ commit }, payload) {
    commit("SET_PAGES", []);
    commit("SET_IS_LOADING", true);
    try {
      let apiUrl = convertUrl("page", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_PAGES", data);
      } else {
        commit("SET_PAGES", data?.result);
        commit("SET_PAGINATION_PAGES", data?.pages);
      }
    } catch (error) {
      commit("SET_PAGES", []);
    }
    commit("SET_IS_LOADING", false);
  },

  async getPagesList({ commit }, payload) {
    try {
      let apiUrl = convertUrl("page", payload);
      let { data } = await axios.get(apiUrl);
      if (Array.isArray(data)) {
        commit("SET_PAGES_LIST", data);
      }
    } catch (error) {
      commit("SET_PAGES_LIST", []);
    }
  },

  async savePage({ dispatch, commit }, payload) {
    try {
      await axios.post("page", payload);
      dispatch("getPages", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async updatePage({ dispatch, commit }, payload) {
    try {
      await axios.put(`page/${payload.id}`, payload);
      dispatch("getPages", { page: 1 });
    } catch (error) {
      if (error.response.status == 400) {
        commit("SET_VALIDATION_ERRORS", error?.response?.data?.message);
      } else {
        commit("SET_VALIDATION_ERRORS", ["No se pudo realizar está operación"]);
      }
      throw new Error(error);
    }
  },

  async deletePage({ dispatch }, id) {
    try {
      await axios.delete(`page/${id}`);
      dispatch("getPages", { page: 1 });
    } catch (error) {
      throw new Error("No se pudo realizar está operación");
    }
  },

  cleanValidationErrors({ commit }) {
    commit("SET_VALIDATION_ERRORS", []);
  },

  updateCurrentPage({ commit }, page) {
    commit("SET_PAGINATION_CURRENT_PAGE", page);
  },
};

const getters = {
  getPages(state) {
    let items = state.pages.map((item) => {
      return {
        ...item,
        module_id: item?.module_id?.id,
        module_name: item?.module_id?.name,
        app_id: item?.module_id?.app_id?.id,
        app_name: item?.module_id?.app_id?.name,
      };
    });
    return items;
  },

  getPagesList(state) {
    return state.pagesList;
  },

  getPaginationPages(state) {
    return state.paginationPages;
  },

  getValidationErrors(state) {
    return state.validationErrors;
  },
};

const pages = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default pages;
